document.addEventListener("DOMContentLoaded", function () {
  const INVALID_NUMBERS = ["88"];
  let numberInputs = [];

  function isInvalid(value) {
    return INVALID_NUMBERS.includes(value.trim());
  }

  function getAddToCartButton() {
    return document.querySelector(".tpo-custom_add_to_cart_selector");
  }

  function setAddToCartState(disabled) {
    const button = getAddToCartButton();
    if (button) {
      button.disabled = disabled;
      button.classList.toggle("disabled", disabled);
      button.style.opacity = disabled ? "0.5" : "1";
      button.style.pointerEvents = disabled ? "none" : "auto";
    }
  }

  function validateAllInputs() {
    let hasInvalid = false;

    numberInputs.forEach((input) => {
      const container = input.closest(".tpo_option-container");
      const errorBox = container?.querySelector(".tpo_error-message");

      if (isInvalid(input.value)) {
        if (errorBox) errorBox.textContent = "Diese Nummer ist nicht erlaubt.";
        input.classList.add("tpo_input-error");
        container?.classList.add("tpo_has-error");
        hasInvalid = true;
      } else {
        if (errorBox) errorBox.textContent = "";
        input.classList.remove("tpo_input-error");
        container?.classList.remove("tpo_has-error");
      }
    });

    setAddToCartState(hasInvalid);
    return !hasInvalid;
  }

  function setupInputValidation() {
    numberInputs.forEach((input) => {
      input.addEventListener("input", validateAllInputs);
      input.addEventListener("blur", validateAllInputs);
    });
  }

  function blockButtonClick() {
    const button = getAddToCartButton();

    if (!button || button.dataset.preventListenerAttached) return;

    button.addEventListener("click", function (e) {
      const isValid = validateAllInputs();
      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log("Blockiert: Ungültige Nummer");
      }
    }, true); // capture mode

    button.dataset.preventListenerAttached = "true";
  }

  function waitUntilReady(retries = 30) {
    numberInputs = Array.from(document.querySelectorAll('input[name*="Nummer"]'));
    const button = getAddToCartButton();

    if (numberInputs.length && button) {
      setupInputValidation();
      validateAllInputs(); // initial
      blockButtonClick();
    } else if (retries > 0) {
      setTimeout(() => waitUntilReady(retries - 1), 300);
    }
  }

  waitUntilReady();
});